<template>
  <DefaultLayout>
  <!-- Reser password Section Begin -->
  <div class="register-login-section spad">
    <!-- Page Preloder -->
    <div class="container">
      <div class="row">
        <div
          class="col-lg-10 offset-lg-1 alert alert-danger"
          v-if="has_error && !success"
        >
          <p v-if="error == 'Validation Error'">
            {{ $t("api.validation_error") }}
          </p>
          <p v-else>
            {{
              $t("auth.error.message", { action: $t("auth.reset-password") })
            }}
          </p>
        </div>
        <div class="col-lg-6 offset-lg-3">
          <div class="loader" v-if="loader"></div>
          <div
            class="register-form"
            v-bind:class="{ 'has-error': has_error && errors.email }"
          >
            <h2>
              {{ $t("auth.change-password") }}
            </h2>
            <form method="post" @submit.prevent="resetPassword" v-if="!success">
              <div
                class="group-input"
                v-bind:class="{
                  'is-invalid': has_error && errors.email !== null,
                }"
              >
                <label
                  for="email"
                  v-bind:class="{
                    'text-danger': has_error && errors.email !== null,
                  }"
                >
                  {{ $t("attr.email") }} *</label
                >
                <input
                  type="text"
                  id="email"
                  v-model="email"
                  v-bind:class="{
                    'is-invalid': has_error && errors.email !== null,
                  }"
                />
                <span
                  class="help-block text-danger"
                  v-if="has_error && errors.email"
                  >{{ errors.email[0] }}</span
                >
              </div>
              <div
                class="group-input"
                v-bind:class="{
                  'is-invalid': has_error && errors.password,
                }"
              >
                <label
                  for="username"
                  v-bind:class="{
                    'text-danger': has_error && errors.password,
                  }"
                >
                  {{ $t("attr.password") }} *</label
                >
                <input
                  type="password"
                  id="password"
                  v-model="password"
                  v-bind:class="{
                    'is-invalid': has_error && errors.password,
                  }"
                />
                <span
                  class="help-block text-danger"
                  v-if="has_error && errors.password"
                  >{{ errors.password[0] }}</span
                >
              </div>

              <div
                class="group-input"
                v-bind:class="{
                  'has-error': has_error && errors.password,
                }"
              >
                <label
                  for="confirm_password"
                  v-bind:class="{
                    'text-danger': has_error && errors.password,
                  }"
                  >{{ $t("action.confirm") }} {{ $t("attr.password") }} *</label
                >
                <input
                  v-bind:class="{
                    'is-invalid': has_error && errors.password,
                  }"
                  type="password"
                  id="confirm_password"
                  v-model="confirm_password"
                />
                <span
                  class="help-block text-danger"
                  v-if="has_error && errors.password"
                  >{{ errors.password[0] }}</span
                >
              </div>
              <button type="submit" class="btn-site btn-auth">
                {{ $t("action.change") }}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</DefaultLayout>
  <!-- Reset Password Form Section End -->
</template>

<script>
import DefaultLayout from '@/layouts/DefaultLayout.vue';

export default {
  data() {
    return {
      token: this.$route.query.token,
      email: "",
      password: "",
      confirm_password: "",
      has_error: false,
      error: "",
      errors: {},
      success: false,
      loader: false,
    };
  },
  components: {
    DefaultLayout,
  },
  methods: {
    resetPassword() {
      var app = this;
      app.loader = true;
      let email = this.email;
      let password = this.password;
      let password_confirmation = this.confirm_password;
      let token = this.token;
      this.$store
        .dispatch("resetPassword", {
          email,
          password,
          password_confirmation,
          token,
        })
        .then(function() {
          app.loader = false;
          app.$router.push("/");
        })
        .catch(function(err) {
          app.has_error = true;
          app.error = err.response.data.message;
          app.errors = err.response.data.data || {};
          app.loader = false;
        });
    },
  },
};
</script>
